export interface UpiConfig {
    upiId: string;
    payeeName: string;
    displayLabel?: string;
    phoneNumber?: string;
}

export interface UserAccountConfig {
    paymentAccounts: number[];
    expenseAccounts: number[];
}

export interface SiteAccountConfig {
    paymentAccounts: number[];
    expenseAccounts: number[];
    upiConfig?: UpiConfig;
    userOverrides?: Record<string, UserAccountConfig>;
}

export interface AccountFilterConfig {
    sites: Record<number, SiteAccountConfig>;
    defaultAccounts: SiteAccountConfig;
    defaultUpiConfig: UpiConfig;
}

// Account ID reference (from database):
// Cash: 1 = Cash - Mogappair, 204 = Cash - Medavakkam
// Bank: 2 = IOB CC, 532 = IDFC Current, 534 = IOB Current
export const accountFilterConfig: AccountFilterConfig = {
    sites: {
        1: {
            paymentAccounts: [1, 2],
            expenseAccounts: [1, 2],
            upiConfig: {
                upiId: '7305949407@okbizaxis',
                payeeName: 'BANYAM MIKRO SUPPLY PLATFORMS PVT LTD',
                displayLabel: 'GPay',
                phoneNumber: '95666 30701',
            },
            userOverrides: {
                mog_superadmin: {
                    paymentAccounts: [1],
                    expenseAccounts: [1],
                },
                acc_superadmin: {
                    paymentAccounts: [2, 532, 534],
                    expenseAccounts: [2, 532, 534],
                },
                manikandan: {
                    paymentAccounts: [1, 2, 532, 534],
                    expenseAccounts: [1, 2, 532, 534],
                },
                superadmin: {
                    paymentAccounts: [1, 2, 532, 534],
                    expenseAccounts: [1, 2, 532, 534],
                },
            },
        },
        4: {
            paymentAccounts: [204, 2],
            expenseAccounts: [204, 2],
            upiConfig: {
                upiId: '7305949407-1@okbizaxis',
                payeeName: 'Mikro Medavakkam',
                displayLabel: 'GPay',
                phoneNumber: '7826943960',
            },
            userOverrides: {
                mdv_superadmin: {
                    paymentAccounts: [204],
                    expenseAccounts: [204],
                },
                acc_superadmin: {
                    paymentAccounts: [2, 532, 534],
                    expenseAccounts: [2, 532, 534],
                },
                manikandan: {
                    paymentAccounts: [204, 2, 532, 534],
                    expenseAccounts: [204, 2, 532, 534],
                },
                superadmin: {
                    paymentAccounts: [204, 2, 532, 534],
                    expenseAccounts: [204, 2, 532, 534],
                },
            },
        },
    },
    defaultAccounts: {
        paymentAccounts: [1, 2, 204],
        expenseAccounts: [1, 2, 204],
    },
    defaultUpiConfig: {
        upiId: '7305949407@okbizaxis',
        payeeName: 'BANYAM MIKRO SUPPLY PLATFORMS PVT LTD',
        displayLabel: 'GPay',
        phoneNumber: '95666 30701',
    },
};

export function getAccountIdsForSite(
    siteId: number | null | undefined,
    context: 'payment' | 'expense',
    username?: string | null
): number[] {
    if (!siteId) {
        return [];
    }

    const siteConfig = accountFilterConfig.sites[siteId];
    if (!siteConfig) {
        return [];
    }

    if (username && siteConfig.userOverrides && siteConfig.userOverrides[username]) {
        const userConfig = siteConfig.userOverrides[username];
        return context === 'payment'
            ? userConfig.paymentAccounts
            : userConfig.expenseAccounts;
    }

    return context === 'payment'
        ? siteConfig.paymentAccounts
        : siteConfig.expenseAccounts;
}
